import {
  login,
  logout,
  getUserInfo
} from '@/api/user'
import { setToken, getToken, getuserinfo, setuserinfo, getconfig, setconfig } from '@/libs/util'

export default {
  state: {
    userInfo: getuserinfo(),
    token: getToken(),
    config: getconfig(),
	
  },
  mutations: {
    setConfig (state, config) {
      state.config = config
      setconfig(config)
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      setuserinfo(userInfo)
    },
    setToken (state, token) {
      state.token = token
      setToken(token)
    }
  },
  getters: {
    userInfo: state => state.userInfo,
    token: state => state.token,
    config: state => state.config,
  },
  actions: {
    // 登录
    handleLogin ({ commit }, { userName, password, smsCode, google2faCode }) {
      userName = userName.trim()
      return new Promise((resolve, reject) => {
        login({
          userName,
          password,
          smsCode,
          google2faCode
        }).then(res => {
          const data = res.data
          commit('setToken', data.data.token)
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit('setToken', '')
        commit('setUserInfo', '')
        window.localStorage.setItem('overallShopToken', '');
		window.localStorage.setItem('oldId', '');
      })
    },
    // 保存系统配置
    handleConfig ({ commit }, config) {
      commit('setConfig', config)
    },
    // 保存系统token
    handleToken ({ commit }, token) {
      commit('setToken', token)
    },
    // 获取用户相关信息
    getUserInfo ({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {
          getUserInfo(state.token).then(res => {
            const data = res.data
            if (data.code == 1) {
              commit('setUserInfo', data.data.userInfo)
              resolve(data)
            }
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    }
  }
}
